import React from "react";
import { Link } from "react-router-dom";
import { GiFairyWings } from "react-icons/gi";
import { FaCheckSquare, FaQuoteLeft } from "react-icons/fa";
import "./HomeAbout.css";

function HomeAbout() {
  return (
    <section className="home-about-section">
      <div className="home-about-container">
        
        <div className="home-about-content-card">
          
          {/* --- HEADER & DIVIDER (Exactly matching HomeSlider) --- */}
          <div className="home-about-header">
            <h2 className="home-about-title">ABOUT RAJPUT SHIKSHA KOSH</h2>
            <div className="home-about-divider">
              <span className="home-about-line"></span>
              <GiFairyWings className="home-about-icon" />
              <span className="home-about-line"></span>
            </div>
          </div>

          {/* --- MAIN HINDI PARAGRAPH --- */}
          <p className="home-about-description">
            राजपूत समाज के हमारे भाइयो के आर्थिक पिछड़ेपन के कारण समाज की 70% आबादी गरीबी रेखा से नीचे जीवनयापन करने को विवश है। इन विषम परिस्थितियों में भी इन आभावग्रस्त राजपूत भाइयो के परिवारों में अनेको बच्चे बहुत ही प्रतिभावान एव होनहार निकल रहे है। इन गुदड़ी के लाल बालको के भविष्य को संवारने हेतु राजपूत समाज में कोई व्यवस्था, मंच अथवा संस्थान नहीं था, जहां ऐसे बालक निसंकोच आवेदन कर यथायोग्य आर्थिक सहायता प्राप्त कर सकें।
          </p>

          {/* --- HIGHLIGHTED INITIATIVE BOX --- */}
          <div className="home-about-founder-box">
            <FaQuoteLeft className="founder-quote-icon" />
            <p>
              इसी भावना से प्रेरित होकर <strong>ठाकुर ओंकार सिंह जी बाबरा आई.ऐ.एस.(रिटा.)</strong> ने चौपासनी स्कूल पूर्व छात्र समिति के हीरक जयंती समारोह में अपने अध्यक्षीय उद्बोधन में इस हेतु <strong>10 करोड़ रूपये का एक स्थाई कोष (कोर्पस फण्ड)</strong> बनाने का प्रस्ताव रखा एव तत्काल अपनी ओर से <strong>5 लाख का चैक</strong> भी प्रदान कर दिया।
            </p>
          </div>

          {/* --- KEY POINTS / HIGHLIGHTS --- */}
          <div className="home-about-highlights-grid">
            <div className="highlight-item">
              <FaCheckSquare className="highlight-icon" />
              <span>समाज की 70% गरीबी रेखा से नीचे जीवनयापन कर रही आबादी का उत्थान।</span>
            </div>
            <div className="highlight-item">
              <FaCheckSquare className="highlight-icon" />
              <span>प्रतिभावान एवं होनहार आभावग्रस्त छात्रों को उचित मंच और मार्गदर्शन।</span>
            </div>
            <div className="highlight-item">
              <FaCheckSquare className="highlight-icon" />
              <span>जरूरतमंद विद्यार्थियों के लिए निसंकोच आर्थिक सहायता की व्यवस्था।</span>
            </div>
            <div className="highlight-item">
              <FaCheckSquare className="highlight-icon" />
              <span>10 करोड़ रुपये के लक्ष्य के साथ स्थाई शिक्षा कोष (Corpus Fund) का निर्माण।</span>
            </div>
          </div>

          {/* --- ACTION BUTTONS --- */}
          <div className="home-about-actions">
            {/* Active (Solid) Button */}
            <Link to="/donate-now" className="home-about-btn active">
              DONATE NOW
            </Link>
            
            {/* Outline Button */}
            <Link to="/history/rajput-shiksha-kosh" className="home-about-btn outline">
              READ MORE
            </Link>
          </div>

        </div>

      </div>
    </section>
  );
}

export default HomeAbout;